import { getFormatDate } from '@/utils/common'
import { UserModule } from '@/store/modules/user'
import { getLabelFromOption } from '@/utils/common'
import { AppModule } from '@/store/modules/app'
import { isUndef } from '@/utils/common'
import { difference } from 'lodash'
import { selectE } from './types';
import { getFormula } from '@/utils/formula';
const reg = /#queId_(\S+?)\$/g;
const defaultString: string[] = ['text', 'number', 'email', 'phone', 'richText', 'datetime']
const defaultArr: string[] = ['associationTable', 'accessory', 'checkbox', 'cascadeSelect', 'region']
const defaultMemberOrDep: string[] = ['member', 'department']
export function initField(item: any) {
  if (item.fieldType === 'number') {
    let v = item.defaultType === 2 ? undefined : (item.defaultValue || '')
    return v ? numberResultFn(Number(v), item) : v
  } else if (defaultString.includes(item.fieldType)) {
    return item.defaultType === 2 ? undefined : (item.defaultValue || '')
  } else if (defaultArr.includes(item.fieldType)) {
    return item.defaultValue ? [...item.defaultValue] : []
  } else if (item.fieldType === 'department') {
    let { fixedValue = '', dynamicValue = '' } = item.defaultValue || {}
    fixedValue = fixedValue ? fixedValue.split(',') : []
    // 当前用户所在部门, 拥有人所在部门
    if (dynamicValue.includes('currentUserDept') || dynamicValue.includes('ownerDept')) {
      let user = AppModule.workerMap[UserModule.user.id] || { departmentIds: [] }
      dynamicValue = user.departmentIds.map((id) => {
        return id + ''
      })
    } else {
      dynamicValue = []
    }
    if (item.selectType === 1) {
      return fixedValue[0] || dynamicValue[0]
    } else {
      return [...fixedValue, ...dynamicValue].join(',')
    }
  } else if (item.fieldType === 'member') {
    let { fixedValue = '', dynamicValue = '' } = item.defaultValue || {}
    fixedValue = fixedValue ? fixedValue.split(',') : []
    // 当前用户
    if (dynamicValue.includes('currentUser')) {
      dynamicValue = [UserModule.user.id + '']
    } else {
      dynamicValue = []
    }
    if (item.selectType === 1) {
      return fixedValue[0] || dynamicValue[0]
    } else {
      return [...fixedValue, ...dynamicValue].join(',')
    }
  } else if (item.fieldType === 'radio' || item.fieldType === 'stepBar') {
    return item.defaultValue || null
  } else if (item.fieldType === 'timeLimit') {
    return { startTime: '', endTime: '' }
  }
}
function memberOrDep(v, field) {
  let values = (v && v.split(',')) || []
  let key = field.fieldType === 'member' ? 'workerMap' : 'deptMap'
  let mapData = AppModule[key]
  return values.map((item) => {
    let worker = mapData[item]
    return worker && worker.name
  })
}
const handleFieldValue = {
  radio(v, field) {
    return field.options.find((option) => {
      return v === option.key
    })
  },
  stepBar(v, field) {
    return field.options.find((option) => {
      return v === option.key
    })
  },
  checkbox(v, field) {
    return field.options.filter((option) => {
      return v.includes(option.key)
    })
  },
  region(v) {
    return v.join('/')
  },
  cascadeSelect(v, field) {
    return getLabelFromOption([...v], field.options).join('/')
  },
  // 返回时间范围的数据
  timeLimit(value) {
    return value ? `${value.startTime || ''}~${value.endTime || ''}` : '';
  },
  statistics(v, field) {
    return v ? `${v} ${field.unit || ''}` : ''
  },
  member: memberOrDep,
  department: memberOrDep
}
export function handleValue(value, item) {
  let field = item
  if (item.fieldType === 'associationField') {
    field = item.sourceField
  }
  let { fieldType } = field
  let handleFn = handleFieldValue[fieldType]
  if (handleFn) {
    return { value: handleFn(value, field), fieldType }
  }
  return { value, fieldType }
}
// 字段内容用于展示
export function handleValueShow(value, item) {
  if (!value || (value instanceof Array && value.length === 0)) {
    return
  }
  let { value: v, fieldType } = handleValue(value, item)
  if (fieldType === 'radio' || fieldType === 'stepBar') {
    return v ? [v] : []
  } else if (fieldType === 'department' || fieldType === 'member') {
    return v.join(',')
  }
  return v
}
// 字段内容用于展示
export function handleValueSimplyShow(value, item) {
  if (!value || (value instanceof Array && value.length === 0)) {
    return
  }
  let { value: v, fieldType } = handleValue(value, item)
  if (fieldType === 'radio' || fieldType === 'stepBar') {
    return v ? v.value : ''
  } else if (fieldType === 'checkbox') {
    return v.map((option) => option.value).join(', ')
  } else if (fieldType === 'department' || fieldType === 'member') {
    return v.join(',')
  }
  return v
}
// 字段内容用于计算
export function handleValueFormula(value, item) {
  if (!value || (value instanceof Array && value.length === 0)) {
    return
  }
  let { value: v, fieldType } = handleValue(value, item)
  if (fieldType === 'radio' || fieldType === 'stepBar') {
    return v ? v.value : ''
  } else if (fieldType === 'checkbox') {
    return v.map((one) => {
      return one.value
    })
  } else if (fieldType === 'number') {
    return Number(v)
  }
  return v
}
export function datetimeResultFn(value, item) {
  if (value instanceof Date) {
    return getFormatDate(value, item.dateType === 1 ? 'date' : 'datetime')
  }
  return value
}
export function commonResultFn(val: any) {
  return val + ''
}
// 对公式的计算结果处理
export function numberResultFn(number1: any, { decimalPoint }) {
  if (typeof number1 === 'number') {
    return number1.toFixed(decimalPoint)
  }
  return number1
}
export const resultFnObj = {
  datetime: datetimeResultFn,
  number: numberResultFn,
  common: commonResultFn
}
// 获取人员，部门动态字段对应的值
export function getDynamicValue(item, that, watchForm = 'form.') {
  let { dynamicValue = '' } = item.defaultValue || {};
  dynamicValue = dynamicValue ? dynamicValue.split(',') : [];
  let unWatchList: any = []
  dynamicValue.forEach(businessId => {
    let unwatch = that.$watch(
      watchForm + '.' + businessId,
      (newV, oldV: any = '') => {
        if (isUndef(newV)) {
          return;
        }
        newV = newV.split(',').filter(id => id);
        if (item.selectType === selectE.radio || item.selectType === 'stepBar') {
          // 单选
          that[watchForm][item.businessId] = newV[0] || '';
        } else {
          oldV = oldV.split(',').filter(id => id);
          let remove: string[] = difference(oldV, newV);
          let value = that[watchForm][item.businessId] || '';
          let valueArr = value.split(',').filter(id => id);
          newV.forEach(id => {
            if (!valueArr.includes(id)) {
              valueArr.push(id);
            }
          });
          remove.forEach(id => {
            let index = valueArr.indexOf(id);
            if (index !== -1) {
              valueArr.splice(index, 1);
            }
          });
          that[watchForm][item.businessId] = valueArr.join(',');
        }
      },
      { immediate: isUndef(that[watchForm][item.businessId]) }
    );
    unWatchList.push(unwatch);
  });
  return unWatchList
}
// 公式计算
export function autoDefault(item, that, watchForm = 'form') {
  if (item.defaultType === 2 && item.defaultValue) {
    let set = new Set<string>();
    const resultFn = resultFnObj[item.fieldType] || resultFnObj.common
    item.defaultValue.replace(reg, (match, $1) => {
      set.add($1);
    });
    if (!set.size && isUndef(that[watchForm][item.businessId])) {
      let formula = getFormula(item);
      that[watchForm][item.businessId] = resultFn(formula.evaluate({}), item)
      return;
    }
    let SheetField = that.fieldsMap;
    let arr = [...set];
    let unWatchList: any = []
    arr.forEach(businessId => {
      let unwatch = that.$watch(
        watchForm + '.' + businessId,
        val => {
          let params = {};
          let hasValue = Array.from(set).every(one => {
            if (!that[watchForm][one]) {
              return false;
            }
            let field = SheetField[one] || {};
            params[one] = handleValueFormula(that[watchForm][one], field);
            return true;
          });
          if (hasValue) {
            let formula = getFormula(item);
            // 返回值处理
            that[watchForm][item.businessId] = resultFn(formula.evaluate(params), item)
          }
        },
        { immediate: isUndef(that[watchForm][item.businessId]) }
      );
      unWatchList.push(unwatch);
    });
    return unWatchList
  }
}

// 用于动态表格的计算
export function calculationDynameicTables(vm: any, fn) {
  debugger
  const { field } = vm
  // 获取公式相关的businessId
  let ids = Array.from(field.defaultValue.matchAll(reg), (a: any) => a[1])
  // 格式化类型
  const resultFn = resultFnObj[field.fieldType] || resultFnObj.common
  let set = new Set<string>(ids);
  let formula = getFormula(field);
  return fn(set, formula, resultFn)
}
